
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8fb5x", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $T1bCI = parcelRequire("T1bCI");


var $jkVM2 = parcelRequire("jkVM2");


var $bJX6u = parcelRequire("bJX6u");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");





var $dh538 = parcelRequire("dh538");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $3jwuS = parcelRequire("3jwuS");


var $e4o8D = parcelRequire("e4o8D");


var $jMyy4 = parcelRequire("jMyy4");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");







/**
 * @generated SignedSource<<2e69ae874c434414ba2d9caf1712f5ee>>
 * @relayHash 81e92b7bef30c91df7d1d5fc36cdd372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72
const $6900e8f8fbd4b479$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "color"
    }, v4 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCallerPermitted"
                        }
                    ]
                },
                {
                    "condition": "isDraft",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "format",
                                    "value": "USER_FRIENDLY"
                                }
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ],
                            "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "AvailableContentStates",
            "kind": "LinkedField",
            "name": "availableContentStates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "customContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v1 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "81e92b7bef30c91df7d1d5fc36cdd372",
            "id": "8135d45ff19837151e07f9b2e9ace783267d3926cd38525a66d27917a361fc72",
            "metadata": {},
            "name": "LivePagesByLineWithContributorsComponentEditorContentStateQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineWithContributorsComponentEditorContentStateQuery($contentId:ID!,$isDraft:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted},contentStateLastUpdated(format:USER_FRIENDLY)@skip(if:$isDraft){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$6900e8f8fbd4b479$var$node.hash = "cbad882df31b75e4699e60f1bcf2ae8b";
var $6900e8f8fbd4b479$export$2e2bcd8739ae039 = $6900e8f8fbd4b479$var$node;









var $6f0Oj = parcelRequire("6f0Oj");


var $63EIj = parcelRequire("63EIj");











var $7om8k = parcelRequire("7om8k");


var $7QM6o = parcelRequire("7QM6o");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");




var $ecnYn = parcelRequire("ecnYn");


var $4FHTF = parcelRequire("4FHTF");


var $3FlVr = parcelRequire("3FlVr");


var $83sfO = parcelRequire("83sfO");





var $1NF8X = parcelRequire("1NF8X");

const $06f66a283e23582e$var$i18n = (0, $cgtv4.defineMessages)({
    addNew: {
        id: "live-pages-features.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "live-pages-features.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $06f66a283e23582e$var$floatingContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'left',
    transition: 'left 600ms',
    marginBottom: 'space.025',
    height: '28px',
    marginTop: 'space.025'
});
const $06f66a283e23582e$export$37ba4ba009bc421f = ({ contentId: contentId, spaceId: spaceId, isDisabled: isDisabled = false, contentType: contentType })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Used when we want to allow the user to select reactions from the summary view popup
    const customIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
        testId: "emoji-add-icon",
        color: "var(--ds-icon-subtle, #505258)",
        label: formatMessage($06f66a283e23582e$var$i18n.addReaction)
    });
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $06f66a283e23582e$var$floatingContainerStyles,
        testId: "live-pages-reactions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1NF8X.ReactionsLoader), {
        contentId: contentId,
        location: contentType === 'blogpost' ? (0, $3FlVr.ReactionLocation).BLOGPOST : (0, $3FlVr.ReactionLocation).PAGE,
        containerId: spaceId,
        containerType: (0, $3FlVr.ReactionContainerType).SPACE,
        contentSubType: isLivePage ? (0, $83sfO.LIVE_PAGE_SUBTYPE) : null,
        summaryViewEnabled: true,
        summaryViewThreshold: 1,
        allowSelectFromSummaryView: true,
        useButtonAlignmentStyling: true,
        summaryViewPlacement: "bottom-start",
        hideNoReactionsText: true,
        readOnly: isDisabled,
        isViewOnly: isDisabled,
        isSubtle: true,
        reactionPickerTriggerIcon: customIcon,
        reactionPickerTriggerText: formatMessage($06f66a283e23582e$var$i18n.addNew),
        useDefaultStyledContainer: true,
        hidePlaceholder: isSSR,
        noRelativeContainer: true,
        noFlexWrap: true,
        hoverableSummaryView: true,
        optimisticallyLoadSummaryEmojis: isSSR,
        renderParticleEffectOnSummaryView: true
    }));
};



var $fImWv = parcelRequire("fImWv");


var $04VgG = parcelRequire("04VgG");





var $5vi32 = parcelRequire("5vi32");










var $gtD4K = parcelRequire("gtD4K");




var $jSnXV = parcelRequire("jSnXV");


var $inPa6 = parcelRequire("inPa6");


var $6qdjm = parcelRequire("6qdjm");


var $3gadb = parcelRequire("3gadb");














var $bQm3c = parcelRequire("bQm3c");


var $AavAW = parcelRequire("AavAW");


var $9BupY = parcelRequire("9BupY");

const $dce34ae8b4376c02$var$i18n = (0, $cgtv4.defineMessages)({
    recentFriendlyWhen: {
        id: "content-header.by-line.live-pages.last.updated.friendly.just.now",
        defaultMessage: "Just now"
    },
    tooltipWhen: {
        id: "content-header.by-line.live-pages.last.updated.tooltip",
        defaultMessage: "Last updated: {day} at {time}"
    }
});
const $dce34ae8b4376c02$export$e4a26074619839f4 = /*#__PURE__*/ (0, $42omo.memo)(({ contentId: contentId, editorApi: editorApi })=>{
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $9BupY.default), {
        variables: {
            contentId: contentId
        },
        notifyOnNetworkStatusChange: true,
        // sets loading to true when refetching, necessary for tooltip
        fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'cache-and-network' // query is preloaded on SSR, but not for SPA
    });
    const latestVersion = data?.content?.nodes?.[0]?.version;
    // We need version in a state variable separate from query data, in order to set it on debouncedSetRecentVersion
    const [version, setVersion] = (0, $42omo.useState)({
        friendlyWhen: latestVersion?.friendlyWhen || null,
        when: latestVersion?.when || null
    });
    const previousRemoteChangeTimeRef = (0, $42omo.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $42omo.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const intl = (0, $8C5kA.default)();
    // Medium dateStyle does not support 'at' combiner, so we're using separate date/time formatters
    const dayFormatter = Intl.DateTimeFormat(locale, {
        dateStyle: 'medium'
    });
    const timeFormatter = Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
    });
    (0, $42omo.useEffect)(()=>{
        // Only show the latest version, which could be from the query or from debouncedSetRecentVersion
        if (latestVersion && JSON.stringify(latestVersion) !== JSON.stringify(version) && latestVersion.when && latestVersion.when >= (version?.when ?? '0')) setVersion({
            friendlyWhen: latestVersion.friendlyWhen ?? null,
            when: latestVersion.when ?? null
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to trigger this on data change
    }, [
        latestVersion
    ]);
    // Fetch that is immediately invoked before the debounced wait period
    // Used on visibility change (when user switches to this tab) and mouseenter
    const debouncedLeadingFetch = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(refetch, 60000, {
            leading: true,
            trailing: false,
            maxWait: 60000
        }), [
        refetch
    ]);
    (0, $42omo.useEffect)(()=>{
        // Fetch last updated time when tab is focused
        const handleVisibilityChange = async ()=>{
            if (document.visibilityState === 'visible') debouncedLeadingFetch(); // Get latest value when user switches back to this tab
        };
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [
        debouncedLeadingFetch
    ]);
    // After a page edit, we know the last change was very recent, so we directly set the version and skip
    // fetching over the network. We still debounce this to avoid rapid calls and prevent perfromance lag
    // when a user starts typing on very large pages
    const debouncedSetRecentVersion = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            setVersion({
                friendlyWhen: intl.formatMessage($dce34ae8b4376c02$var$i18n.recentFriendlyWhen),
                when: new Date().toISOString()
            });
        }, 3000), [
        setVersion,
        intl
    ]);
    // Update time stamp to "Just now" on page edit
    (0, $6qdjm.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            debouncedSetRecentVersion();
        }
    });
    // Cancel any pending timers on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            debouncedLeadingFetch.cancel();
            debouncedSetRecentVersion.cancel();
        };
    }, [
        debouncedLeadingFetch,
        debouncedSetRecentVersion
    ]);
    const tooltipContent = (0, $42omo.useMemo)(()=>{
        if (loading) return null;
        else if (version?.when) {
            // When time since last update is > 48 hours ago, friendlyWhen will be a date (i.e. Oct 31, 2024)
            // However, user time zone conversion of the friendlyWhen date is not currently working on the BE,
            // which means the localized date in the tooltip can differ from the UTC date in the byline.
            // To fix this discrepancy, for now we'll not show the tooltip for dates > 48 hours
            const date = new Date(version?.when);
            const twoDaysInMillis = 172800000;
            if (Date.now() - date.getTime() > twoDaysInMillis) return null;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$dce34ae8b4376c02$var$i18n.tooltipWhen,
                values: {
                    day: dayFormatter.format(date),
                    time: timeFormatter.format(date)
                }
            });
        }
    }, [
        loading,
        version?.when,
        dayFormatter,
        timeFormatter
    ]);
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
        // so returning empty `<ErrorDisplay>` here.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    const handleTooltipShow = ()=>{
        debouncedLeadingFetch();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LivePagesByLineLastUpdated',
                action: 'displayed',
                actionSubject: 'tooltip',
                actionSubjectId: 'bylineLastUpdate',
                attributes: {
                    contentId: contentId,
                    isLivePage: true
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipContent,
        onShow: handleTooltipShow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $AavAW.ByLineLastUpdatedCompact), {
        version: version,
        loading: loading
    }));
});



var $aKxcs = parcelRequire("aKxcs");


var $6iOCg = parcelRequire("6iOCg");

const $3db5129918072e70$export$a6a69f624b6c8259 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(56);
    const { contentId: contentId, author: author, owner: owner, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, generatedBy: generatedBy } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId,
            isDraft: true
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = {
            fetchPolicy: "cache-first",
            variables: t1,
            skip: !Boolean(window.__SSR_RENDERED__)
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6900e8f8fbd4b479$export$2e2bcd8739ae039), t2);
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const eligibleForReactions = isEmbeddedConfluence ? hasReactions : true;
    const renderReactions = (isLivePage || !isUnpublishedDraft) && eligibleForReactions;
    const t3 = renderReactions ? undefined : "space.050";
    let t4;
    if ($[4] !== author || $[5] !== contributorCountWithoutOwner || $[6] !== generatedBy || $[7] !== owner) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "liveDoc",
            contributorCountWithoutOwner: contributorCountWithoutOwner,
            generatedBy: generatedBy
        });
        $[4] = author;
        $[5] = contributorCountWithoutOwner;
        $[6] = generatedBy;
        $[7] = owner;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            paddingBlock: t3
        }, t4);
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const singleLineOwnershipByline = t5;
    const showByLineExtensions = isEmbeddedConfluence ? hasByLineExtensions : true;
    let t6;
    if ($[12] !== contentId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId
        });
        $[12] = contentId;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== contentType || $[17] !== data?.singleContent?.contentState || $[18] !== isKnowledgeBaseSpace || $[19] !== isLivePage || $[20] !== isPublishingContent || $[21] !== userOffline || $[22] !== viewMode) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t7
        }, (contentStateState)=>{
            if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
                contentId: contentId,
                hasSeparator: false,
                isDraft: !isLivePage
            });
            const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
            if (contentStateState.state.contentState || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                floatingToolbarButtonStyle: {
                    alignItems: "center",
                    height: "24px"
                }
            });
            else return null;
        });
        $[15] = contentId;
        $[16] = contentType;
        $[17] = data?.singleContent?.contentState;
        $[18] = isKnowledgeBaseSpace;
        $[19] = isLivePage;
        $[20] = isPublishingContent;
        $[21] = userOffline;
        $[22] = viewMode;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== contentId || $[25] !== editorApi || $[26] !== isLivePage) {
        t9 = isLivePage && !(0, $9wGTI.fg)("confluence_frontend_content_wrapper") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dce34ae8b4376c02$export$e4a26074619839f4), {
            contentId: contentId,
            editorApi: editorApi
        });
        $[24] = contentId;
        $[25] = editorApi;
        $[26] = isLivePage;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== contentId || $[29] !== editorApi) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
            contentId: contentId,
            editorApi: editorApi,
            isInEditor: true
        });
        $[28] = contentId;
        $[29] = editorApi;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== author || $[32] !== contentId || $[33] !== isLivePage || $[34] !== isUnpublishedDraft) {
        t11 = (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
            contentId: contentId,
            contentAuthorId: author.userId
        });
        $[31] = author;
        $[32] = contentId;
        $[33] = isLivePage;
        $[34] = isUnpublishedDraft;
        $[35] = t11;
    } else t11 = $[35];
    let t12;
    if ($[36] !== t10 || $[37] !== t11 || $[38] !== t6 || $[39] !== t8 || $[40] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, t8, t9, t10, t11);
        $[36] = t10;
        $[37] = t11;
        $[38] = t6;
        $[39] = t8;
        $[40] = t9;
        $[41] = t12;
    } else t12 = $[41];
    const byLineExtensions = t12;
    const t13 = showByLineExtensions && byLineExtensions;
    let t14;
    if ($[42] !== contentId || $[43] !== contentType || $[44] !== renderReactions || $[45] !== spaceId || $[46] !== userOffline) {
        t14 = renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06f66a283e23582e$export$37ba4ba009bc421f), {
            contentId: contentId,
            spaceId: spaceId || "",
            isDisabled: userOffline,
            contentType: contentType
        });
        $[42] = contentId;
        $[43] = contentType;
        $[44] = renderReactions;
        $[45] = spaceId;
        $[46] = userOffline;
        $[47] = t14;
    } else t14 = $[47];
    let t15;
    if ($[48] !== t13 || $[49] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t13, t14);
        $[48] = t13;
        $[49] = t14;
        $[50] = t15;
    } else t15 = $[50];
    const ByLineCommonContent = t15;
    const showByLineContributors = isEmbeddedConfluence ? hasByLineContributors : true;
    const t16 = contentType;
    const t17 = showByLineContributors && singleLineOwnershipByline;
    let t18;
    if ($[51] !== ByLineCommonContent || $[52] !== contentId || $[53] !== t16 || $[54] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            contentType: t16
        }, t17, ByLineCommonContent);
        $[51] = ByLineCommonContent;
        $[52] = contentId;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
    } else t18 = $[55];
    return t18;
} : ({ contentId: contentId, author: author, owner: owner, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, generatedBy: generatedBy })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6900e8f8fbd4b479$export$2e2bcd8739ae039), {
        fetchPolicy: 'cache-first',
        variables: {
            contentId: contentId,
            isDraft: true
        },
        skip: !Boolean(window.__SSR_RENDERED__)
    });
    const contributorCountWithoutOwner = contributorsCount - (isOwnerContributor ? 1 : 0);
    const eligibleForReactions = isEmbeddedConfluence ? hasReactions : true;
    const renderReactions = (isLivePage || !isUnpublishedDraft) && eligibleForReactions;
    // reactions are larger than the owner item, so if we arent rending reactions (example: unpublished drafts), we need to add extra padding to avoid the placeholder being too large and causing a jump on load
    // ideally we will get reactions down to the same size as other items (24px) so we can remove this extra padding
    const singleLineOwnershipByline = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: renderReactions ? undefined : 'space.050'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
        owner: owner,
        author: author,
        analyticsSource: "liveDoc",
        contributorCountWithoutOwner: contributorCountWithoutOwner,
        generatedBy: generatedBy
    }));
    const showByLineExtensions = isEmbeddedConfluence ? hasByLineExtensions : true;
    const byLineExtensions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKxcs.BylineClassification), {
        contentId: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        // view mode users should not be able to edit the content state, so we just render the content state.
        if (viewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63EIj.RendererContentState), {
            contentId: contentId,
            hasSeparator: false,
            isDraft: !isLivePage
        });
        // Knowledge space live pages will always show the editable content state component.
        // Other live pages will only show the editable content state component if the content state is already set.
        // This is because a page without a content state is initialized by the ContentStateHoverButton component.
        // SSRd content state will have it's value in gql cache initially instead of the unstated store
        const isSSRRenderedOnLoad = Boolean(data?.singleContent?.contentState) && Boolean(window.__SSR_RENDERED__) && contentStateState.state.shouldRunContentStateEffect;
        if (contentStateState.state.contentState || isKnowledgeBaseSpace || isSSRRenderedOnLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline,
            floatingToolbarButtonStyle: {
                alignItems: 'center',
                height: '24px'
            }
        });
        else return null;
    }), isLivePage && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dce34ae8b4376c02$export$e4a26074619839f4), {
        contentId: contentId,
        editorApi: editorApi
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $04VgG.ReadTime), {
        contentId: contentId,
        editorApi: editorApi,
        isInEditor: true
    }), (isLivePage || !isUnpublishedDraft) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fImWv.AnalyticsByLine), {
        contentId: contentId,
        contentAuthorId: author.userId
    }));
    const ByLineCommonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showByLineExtensions && byLineExtensions, renderReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06f66a283e23582e$export$37ba4ba009bc421f), {
        contentId: contentId,
        spaceId: spaceId || '',
        isDisabled: userOffline,
        contentType: contentType
    }));
    const showByLineContributors = isEmbeddedConfluence ? hasByLineContributors : true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iOCg.SingleLineByLine), {
        contentId: contentId,
        contentType: contentType
    }, showByLineContributors && singleLineOwnershipByline, ByLineCommonContent);
});



var $ausiN = parcelRequire("ausiN");


var $83fWZ = parcelRequire("83fWZ");

const $d898e2893b08edbf$export$7ee26dfdd6e2e40f = ({ contentId: contentId, contentType: contentType, viewMode: viewMode, isPublishingContent: isPublishingContent, isKnowledgeBaseSpace: isKnowledgeBaseSpace, userOffline: userOffline, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const lastLoadedQueryData = (0, $42omo.useRef)(null);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    // eslint-disable-next-line prefer-const
    let { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $fxLAA.default), {
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            // Don't omit versionOverride, embeddedContentRender and limit
            // It's an Apollo bug that if preloader these needs to be match preloaded query
            // Also doesn't work if removing them from preloader variables HOT-109035
            versionOverride: null,
            embeddedContentRender: null,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            includeGeneratedBy: (0, $dh538.fg)('cc-activation-user-generated-by-byline'),
            ...isUnpublishedDraft && !isLivePage && {
                status: [
                    'draft'
                ]
            }
        },
        context: {
            single: true
        },
        fetchPolicy: 'cache-and-network'
    });
    const renderByLine = ()=>{
        // HACK: status: ['draft'] for unpublished drafts results in a weird case where loading is true and we also have the data. Need to investigate this further, but this hack should work for now.
        // happens because isUnpublishedDraft goes from false to true during SSR. ideally we would either always get the right data, or not need it (pass status: ['draft', 'current'] all the time - which could cause caching issues)
        const hasSSRData = renderServerPlaceholder && Boolean(data);
        if (loading && !hasSSRData) {
            // If we're loading because the LivePagesByLineWithContributorsComponent called our
            // fetchAllContributors, then we should continue the render with data
            // cached from the previous query (the one with the low
            // contributorsFetchLimit). It's important to not bring the skeletons back
            // up, as that'd kill the opening of the dropdown.
            if (lastLoadedQueryData.current) data = lastLoadedQueryData.current;
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ausiN.LivePagesByLinePlaceholderComponent), null);
        } else if (!error) lastLoadedQueryData.current = data || null;
        const content = data?.content?.nodes?.[0];
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
            // so returning empty `<ErrorDisplay>` here.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else if (!content) return null;
        const contributorProps = $d898e2893b08edbf$export$6dbfb663651d0abf(content, data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3db5129918072e70$export$a6a69f624b6c8259), {
            ...contributorProps,
            contentId: contentId,
            contentType: contentType,
            viewMode: viewMode,
            isPublishingContent: isPublishingContent,
            isKnowledgeBaseSpace: isKnowledgeBaseSpace,
            userOffline: userOffline,
            editorApi: editorApi,
            isUnpublishedDraft: isUnpublishedDraft,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            hasReactions: hasReactions
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    }, renderByLine());
};
const $d898e2893b08edbf$export$6dbfb663651d0abf = (content, data)=>{
    const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
    const owner = content?.history?.ownedBy && (content?.type === 'page' || content?.type === 'blogpost') ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
    const contributorsCount = data?.contentContributors?.count || 0;
    const isOwnerContributor = data?.contentContributors?.isOwnerContributor;
    const generatedBy = content?.contentProperties?.latest?.generatedBy;
    return {
        author: author,
        owner: owner,
        contributorsCount: contributorsCount,
        isOwnerContributor: isOwnerContributor,
        generatedBy: generatedBy
    };
};


const $d54487d18f54cde1$var$EditorByLineWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$var$Spacer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_16jlkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$var$RightArea = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1tkexy5q _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1tkexy5q _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $d54487d18f54cde1$export$a5fad03eb2e226dc = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, editorAppearanceButton: editorAppearanceButton, isLivePage: isLivePage, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions } = t0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    if (isSpaceOverview) return null;
    if (isLivePage || (0, $9wGTI.fg)("cc_page_experiences_new_editor_byline")) {
        let t1;
        if ($[0] !== contentId || $[1] !== contentType || $[2] !== editorApi || $[3] !== hasByLineContributors || $[4] !== hasByLineExtensions || $[5] !== hasReactions || $[6] !== isKnowledgeBaseSpace || $[7] !== isPublishingContent || $[8] !== isUnpublishedDraft || $[9] !== userOffline || $[10] !== viewMode) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d898e2893b08edbf$export$7ee26dfdd6e2e40f), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline,
                isKnowledgeBaseSpace: isKnowledgeBaseSpace,
                viewMode: viewMode,
                editorApi: editorApi,
                isUnpublishedDraft: isUnpublishedDraft,
                hasByLineContributors: hasByLineContributors,
                hasByLineExtensions: hasByLineExtensions,
                hasReactions: hasReactions
            });
            $[0] = contentId;
            $[1] = contentType;
            $[2] = editorApi;
            $[3] = hasByLineContributors;
            $[4] = hasByLineExtensions;
            $[5] = hasReactions;
            $[6] = isKnowledgeBaseSpace;
            $[7] = isPublishingContent;
            $[8] = isUnpublishedDraft;
            $[9] = userOffline;
            $[10] = viewMode;
            $[11] = t1;
        } else t1 = $[11];
        let t2;
        if ($[12] !== ssrPlaceholderIdProp || $[13] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
                "data-vc": "editor-byline-wrapper",
                ...ssrPlaceholderIdProp
            }, t1);
            $[12] = ssrPlaceholderIdProp;
            $[13] = t1;
            $[14] = t2;
        } else t2 = $[14];
        return t2;
    }
    let t1;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$Spacer, null);
        $[15] = t1;
    } else t1 = $[15];
    let t2;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [
            (0, $bJX6u.ContentStateStateContainer)
        ];
        $[16] = t2;
    } else t2 = $[16];
    let t3;
    if ($[17] !== contentId || $[18] !== contentType || $[19] !== isKnowledgeBaseSpace || $[20] !== isPublishingContent || $[21] !== userOffline) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t2
        }, (contentStateState)=>(contentStateState.state.contentState || isKnowledgeBaseSpace) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
                contentId: contentId,
                contentType: contentType,
                isPublishingContent: isPublishingContent,
                userOffline: userOffline
            }));
        $[17] = contentId;
        $[18] = contentType;
        $[19] = isKnowledgeBaseSpace;
        $[20] = isPublishingContent;
        $[21] = userOffline;
        $[22] = t3;
    } else t3 = $[22];
    let t4;
    if ($[23] !== editorAppearanceButton || $[24] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$RightArea, {
            "data-testId": "editor-byline-right-area"
        }, t3, editorAppearanceButton));
        $[23] = editorAppearanceButton;
        $[24] = t3;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== ssrPlaceholderIdProp || $[27] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
            "data-vc": "editor-byline-wrapper",
            ...ssrPlaceholderIdProp
        }, t4);
        $[26] = ssrPlaceholderIdProp;
        $[27] = t4;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
} : ({ contentId: contentId, contentType: contentType, isPublishingContent: isPublishingContent, userOffline: userOffline, editorAppearanceButton: editorAppearanceButton, isLivePage: isLivePage, isKnowledgeBaseSpace: isKnowledgeBaseSpace, viewMode: viewMode, editorApi: editorApi, isUnpublishedDraft: isUnpublishedDraft, isSpaceOverview: isSpaceOverview, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    if (isSpaceOverview) return null;
    if (isLivePage || (0, $9wGTI.fg)('cc_page_experiences_new_editor_byline')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
        "data-vc": "editor-byline-wrapper",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d898e2893b08edbf$export$7ee26dfdd6e2e40f), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        isKnowledgeBaseSpace: isKnowledgeBaseSpace,
        viewMode: viewMode,
        editorApi: editorApi,
        isUnpublishedDraft: isUnpublishedDraft,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$EditorByLineWrapper, {
        "data-vc": "editor-byline-wrapper",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$Spacer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d54487d18f54cde1$var$RightArea, {
        "data-testId": "editor-byline-right-area"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $bJX6u.ContentStateStateContainer)
        ]
    }, (contentStateState)=>{
        // Knowledge space pages without the new byline will always show the editable content state component in this area.
        // Other pages will only show the editable content state component if the content state is already set.
        // This is because a page without a content state is initialized by the ContentStateHoverButton component.
        return (contentStateState.state.contentState || isKnowledgeBaseSpace) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jkVM2.EditorContentState), {
            contentId: contentId,
            contentType: contentType,
            isPublishingContent: isPublishingContent,
            userOffline: userOffline
        });
    }), editorAppearanceButton)));
};
module.exports["EditorByLineArea"] = $d54487d18f54cde1$export$a5fad03eb2e226dc;

});

parcelRegister("jkVM2", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5f9bfd31a6a2d08f$export$2791e79b1a186ba4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CFAQV",
    name: "EditorContentState",
    loader: async ()=>(await (parcelRequire("g9ETT"))).EditorContentState
});
module.exports["EditorContentState"] = $5f9bfd31a6a2d08f$export$2791e79b1a186ba4;

});

parcelRegister("g9ETT", function(module, exports) {

let $bc2d369cda1d7e24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bc2d369cda1d7e24$var$load("hhss7"),
    $bc2d369cda1d7e24$var$load("ljCe8")
]).then(()=>parcelRequire('iDxDj'));

});

parcelRegister("63EIj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36c7522a305dc07d$export$cbe74da24be93fbd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lwzlE",
    name: "RendererContentState",
    loader: async ()=>(await (parcelRequire("7NNvk"))).RendererContentState
});
module.exports["RendererContentState"] = $36c7522a305dc07d$export$cbe74da24be93fbd;

});

parcelRegister("7NNvk", function(module, exports) {

let $5ae3828cd5594aab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ae3828cd5594aab$var$load("9opeZ").then(()=>parcelRequire('44FvL'));

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("04VgG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47a3fe800ce35819$export$77dedcd16f070a20 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7obd3",
    name: "ReadTime",
    loader: async ()=>(await (parcelRequire("aS1wy"))).ReadTimeLoader
});
module.exports["ReadTime"] = $47a3fe800ce35819$export$77dedcd16f070a20;

});

parcelRegister("aS1wy", function(module, exports) {

let $7ea02130e31b3c3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7ea02130e31b3c3a$var$load("6wr18"),
    $7ea02130e31b3c3a$var$load("ffEVr"),
    $7ea02130e31b3c3a$var$load("19QIS"),
    $7ea02130e31b3c3a$var$load("irgIM")
]).then(()=>parcelRequire('cbZqw'));

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $T1bCI.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("i28ZW", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $42omo = parcelRequire("42omo");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $eSUdr.default)`query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id currentUser{isAdmin}operations{operation targetType}}}`;
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled;
    const { data: data, loading: loading } = (0, $xQxzY.useQuery)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        }
    });
    const hasSpaceOperation = (0, $42omo.useCallback)((spaceOperation)=>{
        return data?.space?.operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
    }, [
        data
    ]);
    return {
        canManageSomeUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4) || hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149) || hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: hasSpaceOperation($981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: hasSpaceOperation($981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: hasSpaceOperation($981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: hasSpaceOperation($981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: hasSpaceOperation($981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: hasSpaceOperation($981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: hasSpaceOperation($981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: hasSpaceOperation($981a614bc39b93a3$export$50faaafd42078ad9),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("iiPY2", function(module, exports) {
$parcel$export(module.exports, "ContentTypeClassification", () => (parcelRequire("2JKSZ")).ContentTypeClassification);
/* ContentTypeClassification.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $jmjWc = parcelRequire("jmjWc");


var $2JKSZ = parcelRequire("2JKSZ");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("2JKSZ")))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $gMc0m.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});
module.exports["ContentTypeClassificationLoader"] = $200528ba24c995ad$export$b3d0b57fae17761b;

});

parcelRegister("2JKSZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $arfOv = parcelRequire("arfOv");


var $9yVdT = parcelRequire("9yVdT");


var $fGQzQ = parcelRequire("fGQzQ");


var $1u6lx = parcelRequire("1u6lx");


var $in5LX = parcelRequire("in5LX");


var $79yie = parcelRequire("79yie");


const $d07cae14ea38bbbf$var$ClassificationTagButtonError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8ozBk",
    name: "ClassificationTagButtonError",
    loader: async ()=>(await (parcelRequire("1gG4q"))).ClassificationTagButtonError
});
const $d07cae14ea38bbbf$var$ContentTypeClassificationComponent = ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: readOnly = true, variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification;
    if (isAddNewClassificationMode) return null;
    if (!currentClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
        contentLevelError: contentLevelError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
        isLoading: isLoading,
        flagStatus: flagStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $arfOv.GenericClassificationTagButton), {
        spaceKey: spaceKey,
        contentType: contentType,
        currentClassification: currentClassification,
        spaceDefaultIsOverridden: spaceDefaultIsOverridden,
        onEditSubmit: handleSubmit,
        menuBehavior: readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit,
        loading: isLoading,
        variant: variant,
        popupPlacementOverride: popupPlacementOverride,
        spacing: spacing,
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId
    }));
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationGetter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($d07cae14ea38bbbf$var$ContentTypeClassificationGetter);
const $d07cae14ea38bbbf$export$e97138dbbe0f9a02 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
module.exports["ContentTypeClassification"] = $d07cae14ea38bbbf$export$e97138dbbe0f9a02;

});

parcelRegister("arfOv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $i2BsV = parcelRequire("i2BsV");


var $jmjWc = parcelRequire("jmjWc");


var $earLp = parcelRequire("earLp");


var $7aj3N = parcelRequire("7aj3N");


var $1u6lx = parcelRequire("1u6lx");


const $e299f5faef060d8a$var$ClassificationReadViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zUIer",
    name: "ClassificationReadViewPopup",
    loader: async ()=>(await (parcelRequire("ddDB2"))).ClassificationReadViewPopup
});

const $e299f5faef060d8a$var$ClassificationEditViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mT5oW",
    name: "ClassificationEditViewPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("8KSlr")))).ClassificationEditViewPopup
});
var $e299f5faef060d8a$export$db79e28c55608769 = /*#__PURE__*/ function(TagButtonMenuBehavior) {
    TagButtonMenuBehavior["readOnly"] = "readOnly";
    TagButtonMenuBehavior["editOnly"] = "editOnly";
    TagButtonMenuBehavior["readAndEdit"] = "readAndEdit";
    return TagButtonMenuBehavior;
}({});
const $e299f5faef060d8a$var$DataClassificationLevelMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $i2BsV.default));
const $e299f5faef060d8a$var$messages = (0, $cgtv4.defineMessages)({
    tooltipMessage: {
        id: "data-classification.content-classification.tag-button.tooltip",
        defaultMessage: "This {contentType} is classified as {classification}"
    }
});
const $e299f5faef060d8a$export$e396cc9924b8f3a0 = ({ spaceKey: spaceKey, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: loading = false, isPopupDisabled: isPopupDisabled = false, menuBehavior: menuBehavior = "readOnly", variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId = 'data-classification-level' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isReadView, setIsReadView] = (0, $42omo.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || (0, $7aj3N.getPopupPlacementForTagVariant)(variant);
    (0, $42omo.useEffect)(()=>{
        if (menuBehavior === "editOnly") setIsReadView(false);
    }, [
        menuBehavior
    ]);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    const getOnChangeLevelClick = ()=>{
        if (menuBehavior === "readOnly") return undefined;
        return ()=>{
            setIsReadView(false);
            handlePopupShown({
                isOpen: true,
                shouldForce: true
            });
        };
    };
    const onEditCancel = (closePopup)=>{
        onEditCancelProp && onEditCancelProp();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const onEditSubmit = (classification, closePopup)=>{
        onEditSubmitProp && onEditSubmitProp(classification);
        onRestoreFocus && onRestoreFocus();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const handlePopupShown = ({ isOpen: isOpen, shouldForce: shouldForce = false })=>{
        if (isOpen) {
            const shouldTrackEvent = !isReadView || shouldForce;
            if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
        }
    };
    const renderPopupComponent = (closePopup)=>{
        return isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
            name: currentClassification.name,
            guideline: currentClassification.guideline,
            onChangeLevelClick: getOnChangeLevelClick()
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
            spaceKey: spaceKey,
            selectedOption: defaultSelectedEditOption,
            onEditCancel: ()=>onEditCancel(closePopup),
            onEditSubmit: (classification)=>onEditSubmit(classification, closePopup),
            loading: loading
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
        testId: buttonTestId,
        name: currentClassification.name,
        guideline: currentClassification.guideline,
        tooltip: formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        }),
        color: currentClassification.color,
        isPopupDisabled: isPopupDisabled,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        renderPopupComponent: renderPopupComponent,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        onPopupShown: ()=>handlePopupShown({
                isOpen: true
            }),
        isIconOnly: variant === (0, $1u6lx.TagButtonUIVariant).iconOnly,
        popupPlacement: popupPlacement,
        spacing: spacing
    }));
};
module.exports["TagButtonMenuBehavior"] = $e299f5faef060d8a$export$db79e28c55608769;
module.exports["GenericClassificationTagButton"] = $e299f5faef060d8a$export$e396cc9924b8f3a0;

});

parcelRegister("7aj3N", function(module, exports) {

var $1u6lx = parcelRequire("1u6lx");

const $8c761859b07fcf40$export$5eaa54a89a0ac = (variant)=>variant === (0, $1u6lx.TagButtonUIVariant).iconOnly ? 'auto' : 'bottom-start';
module.exports["getPopupPlacementForTagVariant"] = $8c761859b07fcf40$export$5eaa54a89a0ac;

});

parcelRegister("1u6lx", function(module, exports) {
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});
module.exports["TagButtonUIVariant"] = $a200b44450c31008$export$f72f271864b318ce;

});

parcelRegister("ddDB2", function(module, exports) {

let $027bcb2a62b71cce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $027bcb2a62b71cce$var$load("iJsKa").then(()=>parcelRequire('ePhVt'));

});

parcelRegister("9yVdT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $9hlns = parcelRequire("9hlns");


var $u9agA = parcelRequire("u9agA");


var $gqqjz = parcelRequire("gqqjz");


var $in5LX = parcelRequire("in5LX");


var $gfkT8 = parcelRequire("gfkT8");


var $93WhG = parcelRequire("93WhG");

const $b9673e4989b5dd09$export$10b01f6c9dc571ea = ({ children: children, flagStatus: flagStatus, isLoading: isLoading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignBlock: "center",
        space: "space.050"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
            description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
            type: "warning",
            showRefresh: false
        })));
};
module.exports["TagLoadingAndFlagWrapper"] = $b9673e4989b5dd09$export$10b01f6c9dc571ea;

});

parcelRegister("gfkT8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1cYlh = parcelRequire("1cYlh");

const $4ebf6b4d55a3b532$var$actionMessage = (0, $cgtv4.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $42omo.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
module.exports["SaveFlag"] = $4ebf6b4d55a3b532$export$ac7557ff3627d244;

});

parcelRegister("1gG4q", function(module, exports) {

let $0ec7eb59ea45e0fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ec7eb59ea45e0fc$var$load("5odbj").then(()=>parcelRequire('2O7oS'));

});

parcelRegister("cuWTe", function(module, exports) {
const $52d439f2e3e46670$export$5d6b4e71896e8f23 = (contentType, isArchived, isDraft, isViewEditOrLive)=>{
    // archived takes priority, since other modes like 'view' can be in this state
    if (isArchived) return 'archived';
    // useGetPageMode *always* returns one of 'live', 'view', or 'edit', but these modes don't apply across all
    // content types - so the content type doesn't have a 'mode' and we should return undefined
    if (contentType === 'page' || contentType === 'blogpost') {
        // then draft takes next priority, since other modes like 'edit' can be in this state
        if (isDraft) return 'draft';
        // technically only pages can be live at the moment, and blogposts wouldn't ever return live, but they *could*
        return isViewEditOrLive;
    } else return undefined;
};
module.exports["getContentMode"] = $52d439f2e3e46670$export$5d6b4e71896e8f23;

});

parcelRegister("lOI2p", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $d8ad782c0a3406d7$export$8cca2d6324f11821 = ({ onClose: onClose, popupRef: popupRef, triggerRef: triggerRef })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const keyDownEvent = ({ key: key })=>{
            if (key === 'Escape' || key === 'Esc') onClose();
        };
        const clickEvent = (event)=>{
            // Refresh button inside Forge app triggers earlier then clickEvent
            // Forge App starts update and popup does not have event.target anymore
            if (!document.body.contains(event.target)) return;
            // Do not close if interaction was performed on the current popup
            if (popupRef && popupRef.contains(event.target)) return;
            // Do not close if interaction was performed on the trigger container
            if (triggerRef && triggerRef.contains(event.target)) return;
            // Do not close if interaction was performed on the ModalDialog with an error
            if (event.target.closest('.atlaskit-portal-container [role=dialog]')) return;
            onClose();
        };
        window.addEventListener('click', clickEvent);
        window.addEventListener('keydown', keyDownEvent);
        return ()=>{
            window.removeEventListener('click', clickEvent);
            window.removeEventListener('keydown', keyDownEvent);
        };
    }, [
        popupRef,
        triggerRef,
        onClose
    ]);
};
module.exports["useInlineDialogCloseManager"] = $d8ad782c0a3406d7$export$8cca2d6324f11821;

});

parcelRegister("jYZsR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $0b4c17fd4adf87fd$export$de5a461d22cbfa90 = ({ onUpdate: onUpdate, popupRef: popupRef, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        if (!popupRef) return;
        const updateWithDelay = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(onUpdate, 100);
        // Workaround to update popup position (by using scheduleUpdate function)
        // on any Forge App resize
        const observer = new ResizeObserver(()=>{
            updateWithDelay();
        });
        observer.observe(popupRef);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupRef,
        onUpdate
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, children);
};
module.exports["ResizeChangeListener"] = $0b4c17fd4adf87fd$export$de5a461d22cbfa90;

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("gektR", function(module, exports) {

var $T1bCI = parcelRequire("T1bCI");


var $jVylI = parcelRequire("jVylI");

class $904056f857fff237$export$e38a13e9484b72c7 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
            isUpdatingAlignment: false,
            isLoadingComplete: false
        };
        this.toggleAlignmentButton = (newAlignmentState)=>{
            if (this.state.alignmentButtonState !== newAlignmentState) this.setState({
                alignmentButtonState: newAlignmentState || (0, $jVylI.TitleAlignmentType).LEFT
            });
        };
        this.setIsLoadingComplete = (isLoadingComplete)=>{
            this.setState({
                isLoadingComplete: isLoadingComplete
            });
        };
        this.setIsUpdatingAlignment = (isUpdatingAlignment)=>{
            this.setState({
                isUpdatingAlignment: isUpdatingAlignment
            });
        };
        this.resetToDefaults = ()=>{
            this.setState({
                alignmentButtonState: (0, $jVylI.TitleAlignmentType).LEFT,
                isUpdatingAlignment: false,
                isLoadingComplete: false
            });
        };
    }
}
module.exports["AlignmentButtonContainer"] = $904056f857fff237$export$e38a13e9484b72c7;

});

parcelRegister("80koo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cpjd2 = parcelRequire("cpjd2");

const $c65634971abef8c1$export$c2019f6d43c6c1ce = ({ wrm: wrm, children: children })=>{
    const [wrmLoadingState, setWrmLoadingState] = (0, $42omo.useState)({
        loaded: false,
        modules: []
    });
    (0, $42omo.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(wrm, (modules)=>{
            setWrmLoadingState({
                loaded: true,
                modules: modules
            });
        }, ()=>{});
    }, [
        wrm
    ]);
    return wrmLoadingState.loaded && children ? children(wrmLoadingState.modules) : null;
};
module.exports["RequireLegacyWRM"] = $c65634971abef8c1$export$c2019f6d43c6c1ce;

});

parcelRegister("aV3a0", function(module, exports) {

var $kae7O = parcelRequire("kae7O");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $9wEpK = parcelRequire("9wEpK");


var $jMyy4 = parcelRequire("jMyy4");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $i9VoI = parcelRequire("i9VoI");


var $7Sm4c = parcelRequire("7Sm4c");


var $5kqgA = parcelRequire("5kqgA");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gzIc1 = parcelRequire("gzIc1");


var $jVylI = parcelRequire("jVylI");

const $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery = (0, $kae7O.default);
const $c042cea05c5afe3c$export$56ad806c83a5bd5e = (queryData)=>queryData?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.find((node)=>node?.key === 'page-title-property-draft');
const $c042cea05c5afe3c$var$i18n = (0, $cgtv4.defineMessages)({
    errorFlagTitle: {
        id: "content-topper.page-title.alignment.error.title",
        defaultMessage: "We couldn\u2019t update the title alignment"
    },
    errorFlagDescription: {
        id: "content-topper.page-title.alignment.error.description",
        defaultMessage: "Try again, or refresh the page."
    }
});
const $c042cea05c5afe3c$export$e3e4716593714d84 = ({ contentId: contentId, propertyKey: propertyKey = 'page-title-property-draft', isDelete: isDelete = false, loadTitleContentProperties: loadTitleContentProperties = false, updateAlignmentState: updateAlignmentState, updateCoverPictureWidthState: updateCoverPictureWidthState, contentType: contentType, flags: flags, updateIsLoadingComplete: updateIsLoadingComplete })=>{
    const isInitialLoadComplete = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const isTitleCenteredInitial = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(false);
    const handleError = (0, $42omo.useCallback)((error, suppressErrors)=>{
        const isUnauthOrNotFoundError = (0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error);
        if (!isUnauthOrNotFoundError) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        if (!suppressErrors) flags?.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c042cea05c5afe3c$var$i18n.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c042cea05c5afe3c$var$i18n.errorFlagDescription)
        });
    }, [
        flags
    ]);
    const getAlignmentFromContentProperty = (response)=>{
        const titlePropertyContent = $c042cea05c5afe3c$export$56ad806c83a5bd5e(response);
        if (titlePropertyContent?.value) try {
            return (0, $gzIc1.contentPropertyHelper)(titlePropertyContent)?.titleLayoutAlignment || (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        } catch (e) {
            handleError(e, false);
            return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
        }
        else return (0, $jVylI.defaultPropertyValue).titleLayoutAlignment;
    };
    const onCompleted = (response_0)=>{
        const coverPictureWidth = response_0.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
        updateAlignmentState?.(getAlignmentFromContentProperty(response_0));
        updateCoverPictureWidthState?.(coverPictureWidth);
    };
    const { data: data, networkStatus: networkStatus, refetch: refetchProperties } = (0, $jMyy4.useQueryInterop)($c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery, {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        fetchPolicy: Boolean(window.__SSR_RENDERED__) ? 'cache-first' : 'cache-and-network',
        // cache-and-network is required for: edit cover width, transition out of edit, transition back to edit for same page (for Live Docs and Classic pages)
        onError: (error_0)=>{
            handleError(error_0, true);
        },
        skip: !(loadTitleContentProperties || Boolean(window.__SSR_RENDERED__)),
        notifyOnNetworkStatusChange: true
    });
    const isTitleAlignmentLoading = networkStatus === (0, $9wEpK.NetworkStatus).loading && !data;
    const refetchLoading = networkStatus === (0, $9wEpK.NetworkStatus).refetch;
    const coverImageWidthCached = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth;
    isTitleCenteredInitial.current = (Boolean(window.__SSR_RENDERED__) || !isTitleAlignmentLoading) && getAlignmentFromContentProperty(data) === (0, $jVylI.TitleAlignmentType).CENTER;
    if (!isInitialLoadComplete.current && loadTitleContentProperties && data) {
        isInitialLoadComplete.current = true;
        onCompleted(data);
        updateIsLoadingComplete?.(true);
    }
    const { updateContentProperty: updateContentProperty, updateContentPropertyResult: { loading: isUpdatingAlignment } = {} } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const onPageTitlePropertyUpdatedSubscriptionData = (0, $42omo.useCallback)((_eventName, response_1)=>{
        const { pageTitlePropertyUpdated: pageTitlePropertyUpdated } = response_1 || {};
        try {
            const value = JSON.parse(pageTitlePropertyUpdated?.value);
            updateAlignmentState?.(value?.titleLayoutAlignment);
        } catch (error_1) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error_1, {
                attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
            });
            (0, $7Sm4c.markErrorAsHandled)(error_1);
        }
    }, [
        updateAlignmentState
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType || 'page',
        delta: 'pageTitlePropertyUpdated',
        onDataReceived: onPageTitlePropertyUpdatedSubscriptionData,
        subscriberId: 'useTitleContentPropertiesForEditor'
    });
    const updatePageTitleProperty = (0, $42omo.useCallback)(async (propertyValue)=>{
        try {
            const getVersionNumber = (data_0)=>data_0?.content?.nodes?.[0]?.pageTitleDraft?.nodes?.[0]?.version?.number || 0;
            const versionData = await refetchProperties();
            const versionNumber = getVersionNumber(versionData.data);
            const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
            await updateContentProperty({
                propertyKey: propertyKey,
                propertyValue: propertyValue,
                isDelete: isDelete,
                hasExistingProperty: versionNumber > 0,
                shouldOptimisticResponse: true,
                options: {
                    update: ()=>{
                        try {
                            const cacheData = (0, $l1uFv.readQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                }
                            });
                            cacheData.content.nodes[0].pageTitleDraft.nodes[0] = {
                                ...cacheData.content.nodes[0].pageTitleDraft.nodes[0],
                                id: contentId,
                                key: propertyKey,
                                value: JSON.stringify(propertyValue),
                                version: {
                                    number: newVersionNumber,
                                    __typename: 'Version'
                                }
                            };
                            (0, $fEmGS.writeQueryInterop)({
                                query: $c042cea05c5afe3c$var$useTitleContentPropertiesForEditorQuery,
                                variables: {
                                    contentId: contentId,
                                    status: [
                                        'current',
                                        'draft',
                                        'archived'
                                    ]
                                },
                                data: data
                            });
                        } catch (error_2) {
                            throw new Error(` failed to write to cache while updating ${propertyKey} content property after user updated page title${error_2.message}`);
                        }
                    }
                }
            });
        } catch (err) {
            handleError(err, false);
        }
    }, [
        propertyKey,
        contentId,
        isDelete,
        updateContentProperty,
        refetchProperties,
        data,
        handleError
    ]);
    return {
        isUpdatingAlignment: isUpdatingAlignment || refetchLoading,
        updatePageTitleProperty: updatePageTitleProperty,
        onCompleted: // exported for testing purposes
        onCompleted,
        isTitleAlignmentLoading: isTitleAlignmentLoading,
        isTitleCenteredInitial: isTitleCenteredInitial.current,
        coverImageWidthCached: coverImageWidthCached
    };
};
module.exports["useTitleContentPropertiesForEditor"] = $c042cea05c5afe3c$export$e3e4716593714d84;

});


//# sourceMappingURL=EditorByLineArea.14e3c68b.js.map
